module.exports = require('./helpers/bundle-url').getBundleURL('7jzoL') + "logo-dark.eefe0b7f.svg";